import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) {
      toast.success("Signed in");
      navigate(r.user?.role === "admin" ? "/admin" : "/account");
    } else {
      toast.error(r.error);
    }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="bg-white min-h-[70vh]" data-testid="login-page">
      <div className="max-w-md mx-auto px-4 sm:px-6 py-16">
        <div className="rh-overline mb-3">Account</div>
        <h1 className="font-display font-black text-4xl tracking-tighter mb-8">Sign In</h1>

        <button data-testid="google-signin-btn" onClick={googleLogin} className="w-full border border-[#0a0a0a] py-3 px-4 text-sm font-semibold uppercase tracking-widest hover:bg-[#0a0a0a] hover:text-white flex items-center justify-center gap-3">
          <svg width="18" height="18" viewBox="0 0 18 18"><path fill="#4285F4" d="M17.64 9.2c0-.64-.05-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 01-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z"/><path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.81.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.34A9 9 0 009 18z"/><path fill="#FBBC05" d="M3.97 10.72A5.4 5.4 0 013.68 9c0-.6.1-1.18.29-1.72V4.94H.96A9 9 0 000 9c0 1.45.35 2.83.96 4.06l3.01-2.34z"/><path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.43 1.35l2.58-2.58A9 9 0 00.96 4.94l3.01 2.34C4.68 5.16 6.66 3.58 9 3.58z"/></svg>
          Continue with Google
        </button>

        <div className="flex items-center gap-3 my-6">
          <div className="flex-1 h-px bg-[#e5e5e5]" />
          <span className="text-xs text-[#4a4a4a] font-mono">OR</span>
          <div className="flex-1 h-px bg-[#e5e5e5]" />
        </div>

        <form onSubmit={submit} className="space-y-4">
          <label className="block">
            <span className="block text-xs uppercase tracking-widest text-[#4a4a4a] mb-2">Email</span>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border border-[#0a0a0a] px-3 py-3 text-sm" />
          </label>
          <label className="block">
            <span className="block text-xs uppercase tracking-widest text-[#4a4a4a] mb-2">Password</span>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border border-[#0a0a0a] px-3 py-3 text-sm" />
          </label>
          <button data-testid="login-submit" type="submit" disabled={busy} className="rh-btn-primary w-full">{busy ? "Signing in…" : "Sign In"}</button>
        </form>

        <p className="mt-6 text-sm text-[#4a4a4a]">
          Need an account? <Link to="/register" className="underline font-semibold text-[#0a0a0a]" data-testid="register-link">Create one</Link>
        </p>
      </div>
    </div>
  );
}
